import React from "react";
import { STYLE_PREFIX } from "../const";
import "./style.less";
var Button = function Button(props) {
  var type = props.type,
    children = props.children,
    onClick = props.onClick;
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(STYLE_PREFIX, "-custom-button ").concat(type),
    onClick: onClick
  }, children);
};
export default Button;